import {createSlice} from "@reduxjs/toolkit";
import {MESSAGE_TYPE_ERROR, MESSAGE_TYPE_SUCCESS, ROOM_STATUS_FREE} from "../constants/default";
import {deviceLeds} from "../services/deviceLeds";
import { APP_VERSION } from "../constants/versionConstants";

export const Slice = createSlice({
    name: "data",
    initialState: {
        version: APP_VERSION,
        serverUrl: '',
        socketUrl: null,
        soketiUrl: null,
        soketiUrl: null,
        defaultConfig: {
            title: '',
            allow_booking: 1,
            can_checkin: 0,
            grace_period: 15,
            hide_booking_title: 0,
            hide_booker: 0,
            hide_controls: 0,
            hide_next_booking: 0,
            hide_current_booking_details: 0,
            hide_schedule: 0,
            hide_header_info: 0,
            skip_booking_form: 0,
            default_booking_duration: 30,
            require_login_actions: 0,
            login_type: 'default',
            background_image: null,
            background_color: 'rgba(0,0,0,0.5)',
            time_format: 'ampm',
            date_format: "dddd, MMMM Do YYYY",
            light_driver: 'none',
            hardware_mode: 'none',
            component_color: '#5B41D9',
            errorTimeout: 10,
            language: 'en',
            add_conference_link: null,
            timezone: "Europe/London",
            schedule: {
                1: {day_id: 1, start: 8, end: 17, blocked: 0, strict: 0},
                2: {day_id: 2, start: 8, end: 17, blocked: 0, strict: 0},
                3: {day_id: 3, start: 8, end: 17, blocked: 0, strict: 0},
                4: {day_id: 4, start: 8, end: 17, blocked: 0, strict: 0},
                5: {day_id: 5, start: 8, end: 17, blocked: 0, strict: 0},
                6: {day_id: 6, start: 8, end: 17, blocked: 0, strict: 0},
                7: {day_id: 7, start: 8, end: 17, blocked: 0, strict: 0}
            },
        },
        config: {
            title: '',
            allow_booking: 1,
            can_checkin: 0,
            grace_period: 15,
            hide_booking_title: 0,
            hide_booker: 0,
            hide_controls: 0,
            hide_next_booking: 0,
            hide_current_booking_details: 0,
            hide_schedule: 0,
            hide_header_info: 0,
            skip_booking_form: 0,
            default_booking_duration: 30,
            require_login_actions: 0,
            login_type: 'default',
            background_image: require('../../assets/images/meeting-room-display-default.png'),
            background_color: 'rgba(0,0,0,0.5)',
            time_format: 'ampm',
            date_format: "dddd, MMMM Do YYYY",
            light_driver: 'none',
            hardware_mode: 'none',
            component_color: '#5B41D9',
            errorTimeout: 10,
            language: 'en',
            timezone: "Europe/London",
            schedule: {
                1: {day_id: 1, start: 8, end: 17, blocked: 0, strict: 0},
                2: {day_id: 2, start: 8, end: 17, blocked: 0, strict: 0},
                3: {day_id: 3, start: 8, end: 17, blocked: 0, strict: 0},
                4: {day_id: 4, start: 8, end: 17, blocked: 0, strict: 0},
                5: {day_id: 5, start: 8, end: 17, blocked: 0, strict: 0},
                6: {day_id: 6, start: 8, end: 17, blocked: 0, strict: 0},
                7: {day_id: 7, start: 8, end: 17, blocked: 0, strict: 0}
            }
        },
        currentState: null,
        authenticated: false,
        token: null,

        selectedInterval: [],
        bookingList: [],
        currentBooking: null,
        nextBooking: null,
        roomStatus: ROOM_STATUS_FREE,

        //tomove visibility
        logsVisible: false,
        bookModalVisible: false,
        connectionStatus: 0,
        endModalVisible: false,
        extendModalVisible: false,
        spaceQrModalVisible: false,
        bookingListExtended: false,

        loading: false,
        language: 'en',

        message: null,
        actionAuthentication: null,
        connectionLogs: [],
        maintenance: null,
        codePushReady: true,
        checkingForUpdates: false,

        // Privacy protection
        showPrivacyBlur: false,

        // Runtime Application Self-Protection (RASP)
        raspStatus: 'uninitialized', // 'uninitialized', 'initializing', 'active', 'error'
        raspThreatLevel: 'none', // 'none', 'low', 'medium', 'high', 'critical'
        raspSecurityEvents: [],
        raspDetectionEnabled: true
    },
    reducers: {
        setVersion: (state,action) => {
            state.version = action.payload
        },
        setCurrentState: (state, action) => {
            state.currentState = action.payload;
        },
        setServerUrl: (state, action) => {
            state.serverUrl = action.payload;
        },
        setConfig: (state, action) => {
            state.config = action.payload
        },
        setError: (state, action) => {
            state.message = action.payload ? {
                type: MESSAGE_TYPE_ERROR,
                message: action.payload
            } : null
        },
        setSuccess: (state, action) => {
            state.message = action.payload ? {
                type: MESSAGE_TYPE_SUCCESS,
                message: action.payload
            } : null
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setLanguage: (state, action) => {
            state.language = action.payload;
        },
        setBookingList: (state, action) => {
            const current = action.payload.find( (booking, index) => {
                if (booking.current) {
                    return booking;
                }
            })

            const next = action.payload.find( (booking, index) => {
                if (booking.next) {
                    return booking;
                }
            })

            const ledsState = current ? (!current?.checkin && state?.config?.has_checkin ? 'checkin' : 'busy') : 'available';
            deviceLeds(ledsState, state?.config?.light_driver);

            state.bookingList = action.payload
            state.currentBooking = current ? current : null
            state.nextBooking = next ? next : null
        },


        setBookingListExtended: (state,action) => {
            state.bookingListExtended = action.payload
        },
        setBookModalVisibility: (state, action) => {
            state.bookModalVisible = action.payload;
        },
        setEndModalVisibility: (state, action) => {
            state.endModalVisible = action.payload;
        },
        setExtendModalVisibility: (state, action) => {
            state.extendModalVisible = action.payload;
        },
        setSpaceQrModalVisibility: (state, action) => {
            state.spaceQrModalVisible = action.payload
        },
        setSelectedInterval: (state, action) => {
            state.selectedInterval = action.payload;
        },
        setCurrentBooking: (state, action) => {
            state.currentBooking = action.payload;
        },
        setNextBooking: (state, action) => {
            state.nextBooking = action.payload;
        },
        setRoomStatus: (state, action) => {
            state.roomStatus = action.payload;
        },
        setConnectionStatus: (state, action) => {
            state.connectionStatus = action.payload
        },
        setMessage: (state, action) => {
            state.message = action.payload;
        },
        setSocketUrl: (state, action) => {
            state.socketUrl = action.payload;
        },
        setSoketiUrl: (state, action) => {
            state.soketiUrl = action.payload;
        },
        setToken: (state, action) => {
            state.token = action.payload;
        },
        setAuthenticated: (state, action) => {
            state.authenticated = action.payload;
        },
        setActionAuthentication: (state, action) => {
            state.actionAuthentication = action.payload;
        },
        setLogsVisibility: (state, action) => {
            state.logsVisible = action.payload;
        },
        setConnectionLogs: (state, action) => {
            state.connectionLogs = [...state.connectionLogs, action.payload]
        },
        clearConnectionLogs: (state, action) => {
            state.connectionLogs = []
        },
        setMaintenance: (state, action) => {
            state.maintenance = action.payload
        },
        setCodePushReady: (state, action) => {
            state.codePushReady = action.payload;
        },
        setCheckingForUpdates: (state, action) => {
            state.checkingForUpdates = action.payload;
        },
        setShowPrivacyBlur: (state, action) => {
            state.showPrivacyBlur = action.payload;
        },
        // RASP reducers
        setRaspStatus: (state, action) => {
            state.raspStatus = action.payload;
        },
        setRaspThreatLevel: (state, action) => {
            state.raspThreatLevel = action.payload;
        },
        addRaspSecurityEvent: (state, action) => {
            state.raspSecurityEvents.push({
                ...action.payload,
                timestamp: new Date().toISOString(),
                id: Date.now() + Math.random()
            });
            // Keep only last 100 events to prevent memory issues
            if (state.raspSecurityEvents.length > 100) {
                state.raspSecurityEvents = state.raspSecurityEvents.slice(-100);
            }
        },
        clearRaspSecurityEvents: (state) => {
            state.raspSecurityEvents = [];
        },
        setRaspDetectionEnabled: (state, action) => {
            state.raspDetectionEnabled = action.payload;
        }
    }
});


export const getVersion = (state) => state.data.version;
export const getCurrentState = (state) => state.data.currentState;
export const getServerUrl = (state) => state.data.serverUrl;
export const getConfig = (state) => state.data.config;
export const getLoading = (state) => state.data.loading;
export const getLanguage = (state) => state.data.language;
export const getBookingList = (state) => state.data.bookingList;
export const getBookingListExtended = (state) => state.data.bookingListExtended;
export const getBookModalVisibility = (state) => state.data.bookModalVisible
export const getEndModalVisibility = (state) => state.data.endModalVisible
export const getExtendModalVisibility = (state) => state.data.extendModalVisible
export const getSpaceQrModalVisibility = (state) => state.data.spaceQrModalVisible
export const getSelectedInterval = (state) => state.data.selectedInterval
export const getCurrentBooking = (state) => state.data.currentBooking
export const getNextBooking = (state) => state.data.nextBooking
export const getRoomStatus = (state) => state.data.roomStatus
export const getConnectionStatus = (state) => state.data.connectionStatus
export const getExtendPeriod = (state) => state.data.extendPeriod
export const getComponentColor = (state) => state.data.config.component_color
export const getMessage = (state) => state.data.message
export const getSocketUrl = (state) => state.data.socketUrl
export const getSoketiUrl = (state) => state.data.soketiUrl
export const getToken = (state) => state.data.token
export const getLogsVisible = (state) => state.data.logsVisible
export const getAuthenticated = (state) => state.data.authenticated
export const getActionAuthentication = (state) => state.data.actionAuthentication
export const getConnectionLogs = (state) => state.data.connectionLogs
export const getMaintenance = (state) => state.data.maintenance
export const getCodePushReady = (state) => state.data.codePushReady;
export const getCheckingForUpdates = (state) => state.data.checkingForUpdates
export const getShowPrivacyBlur = (state) => state.data.showPrivacyBlur;

// RASP selectors
export const getRaspStatus = (state) => state.data.raspStatus;
export const getRaspThreatLevel = (state) => state.data.raspThreatLevel;
export const getRaspSecurityEvents = (state) => state.data.raspSecurityEvents;
export const getRaspDetectionEnabled = (state) => state.data.raspDetectionEnabled;

export const {
    setVersion,
    setCurrentState,
    setServerUrl,
    setConfig,
    setLoading,
    setLanguage,
    setBookingList,
    setBookingListExtended,
    setBookModalVisibility,
    setEndModalVisibility,
    setExtendModalVisibility,
    setSpaceQrModalVisibility,
    setConnectionStatus,
    setSelectedInterval,
    setCurrentBooking,
    setRoomStatus,
    setSuccess,
    setError,
    setMessage,
    setSocketUrl,
    setSoketiUrl,
    setToken,
    setAuthenticated,
    setActionAuthentication,
    setLogsVisibility,
    setConnectionLogs,
    clearConnectionLogs,
    setMaintenance,
    setCodePushReady,
    setCheckingForUpdates,
    setShowPrivacyBlur,
    setRaspStatus,
    setRaspThreatLevel,
    addRaspSecurityEvent,
    clearRaspSecurityEvents,
    setRaspDetectionEnabled
} = Slice.actions;
export default Slice.reducer;